import { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "@/lib/firebase";
import type { Training } from "@/lib/types";

export function useTrainings(clubId: string | undefined) {
  const [trainings, setTrainings] = useState<(Training & { id: string })[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId) {
      setTrainings([]);
      setLoading(false);
      return;
    }
    const q = query(collection(db, "clubs", clubId, "trainings"), orderBy("date"));
    const unsub = onSnapshot(
      q,
      (snap) => {
        const items = snap.docs.map((d) => ({ id: d.id, ...(d.data() as Training) }));
        setTrainings(items);
        setLoading(false);
      },
      () => setLoading(false)
    );
    return unsub;
  }, [clubId]);

  return { trainings, loading };
}
